/* Guard: this file is loaded by the footer AND by some sections. Running twice made every click toggle twice (FAQ could not open). */
if (!window.__maInit) {
window.__maInit = true;
document.addEventListener('DOMContentLoaded', function () {
  var revealEls = document.querySelectorAll('.ma-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var accItems = document.querySelectorAll('.ma-accordion-item');
  accItems.forEach(function (item) {
    var trigger = item.querySelector('.ma-accordion-item__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  });

  var badge = document.getElementById('ma-cart-badge');
  var drawer = document.getElementById('ma-cart-drawer');
  var overlay = document.getElementById('ma-cart-overlay');
  var itemsEl = document.getElementById('ma-drawer-items');
  var totalEl = document.getElementById('ma-drawer-total');
  var badgeCount = document.getElementById('ma-cart-badge-count');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function renderCart(cart) {
    if (!cart) return;
    if (cart.item_count > 0) {
      if (badge) badge.classList.add('is-visible');
      if (badgeCount) badgeCount.textContent = cart.item_count;
    } else if (badge) {
      badge.classList.remove('is-visible');
    }
    if (itemsEl) {
      itemsEl.innerHTML = '';
      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'ma-drawer__item';
        row.innerHTML =
          '<img src="' + (item.image || '') + '" alt="">' +
          '<div><div class="ma-drawer__item-title">' + item.product_title + '</div>' +
          '<div class="ma-drawer__item-qty">Qty ' + item.quantity + '</div></div>' +
          '<div class="ma-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<button type="button" class="ma-drawer__item-remove" data-cart-remove="' + escapeHtml(item.key) + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2L4 6"/><path d="M10 11v6M14 11v6"/></svg>' +
          '</button>';
        itemsEl.appendChild(row);
      });
    }
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function removeFromCart(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error('Remove from cart failed', err); });
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      removeFromCart(btn.getAttribute('data-cart-remove'));
    });
  }

  if (badge) badge.addEventListener('click', function () { openDrawer(); fetchCart(); });
  var closeBtn = document.querySelector('.ma-drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* Add to Cart on the home page and product pages now opens the SAME cart drawer as View All (with the upsell) */
  document.querySelectorAll('.ma-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.ma-add-btn');
      var formData = new FormData(form);
      var themeDrawer = document.querySelector('cart-drawer');
      var useThemeDrawer = themeDrawer && typeof themeDrawer.renderContents === 'function';
      if (useThemeDrawer) {
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      }
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (btn) {
            var originalHTML = btn.innerHTML;
            btn.classList.add('is-added');
            btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> Added';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = originalHTML;
            }, 1800);
          }
          if (useThemeDrawer && state && state.sections) {
            themeDrawer.renderContents(state);
          } else {
            fetchCart();
            openDrawer();
          }
        })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  fetchCart();
});
}
